import { useState, useEffect, useRef } from "react";
import Header from "../../common/layout/header";
import Footer from "../../common/layout/footer";
import Sidebar from "../../common/sidebar";
import DataTable from "react-data-table-component";
import { http } from "../../helper";
import { BaseUrl } from "../../common/config";
import { useTranslation } from "react-i18next";
import Popup from "../../common/popup";
import * as XLSX from "sheetjs-style";
import { saveAs } from "file-saver";
import moment from "moment";
import AlertPopup from "../../common/alertPopup";
import { dateformatwithuktime } from "../../utilityfunctions";
import ConfirmationPopup from "../../common/confirmationPopup";
import { canAction } from "../../common/permissionhelper";
const CustomerLeadForms = () => {
  const { t } = useTranslation();
  const [customerLeadForms, setCustomerLeadForms] = useState([]);
  const [tempList, setTempList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [selectedForm, setSelectedForm] = useState(null);
  const [showCallConfirm, setShowCallConfirm] = useState(false);
  const [selectedCallRow, setSelectedCallRow] = useState(null);
  const [selectedApproveRow, setSelectedApproveRow] = useState(null);
  const [showPushConfirm, setShowPushConfirm] = useState(false);
  const [selectedPushRow, setSelectedPushRow] = useState(null);
  const [showViewPopup, setShowViewPopup] = useState(false);
  const [selectedViewLead, setSelectedViewLead] = useState(null);
  const [searchField, setSearchField] = useState("name");
  const [searchValue, setSearchValue] = useState("");
  const [showExportConfirm, setShowExportConfirm] = useState(false);
  const [showNoDataAlert, setShowNoDataAlert] = useState(false);
  const [alertErrorPopup, setAlertErrorPopup] = useState(false);
  const [alertErrorMessage, setAlertErrorMessage] = useState("");
  const [showApprovePopup, setShowApprovePopup] = useState(false);
  const [pushType, setPushType] = useState("");
  const [approveComment, setApproveComment] = useState("");
  const [pushTypeError, setPushTypeError] = useState(false);
  const [commentError, setCommentError] = useState(false);
  const [showLogPopup, setShowLogPopup] = useState(false);
  const [approvalLogs, setApprovalLogs] = useState([]);
  const [selectedLogLead, setSelectedLogLead] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isCallProcessing, setIsCallProcessing] = useState(false);
  const [isApproving, setIsApproving] = useState(false);
  const [showAuthConfirm, setShowAuthConfirm] = useState(false);
  const [selectedLead, setSelectedLead] = useState(null);
  const [isAuthorizing, setIsAuthorizing] = useState(false);
  const [showAuthSuccess, setShowAuthSuccess] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const filterRef = useRef(null);
  const [showMoreFilter, setShowMoreFilter] = useState(false);
  const [filterStatus, setFilterStatus] = useState([]);
  const [filterSteps, setFilterSteps] = useState([]);
  const [draftFilterStatus, setDraftFilterStatus] = useState([]);
  const [draftFilterSteps, setDraftFilterSteps] = useState([]);
  const [appliedFilterStatus, setAppliedFilterStatus] = useState([]);
  const [appliedFilterSteps, setAppliedFilterSteps] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [showEditPopup, setShowEditPopup] = useState(false);
  const [editFormData, setEditFormData] = useState({});
  const [editErrors, setEditErrors] = useState({});
  const [sectorOptions, setSectorOptions] = useState([]);
  const [isSectorLoading, setIsSectorLoading] = useState(false);
  const [refreshingId, setRefreshingId] = useState(null);
  const [isEditLoading, setIsEditLoading] = useState(false);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [alertSuccessMessage, setAlertSuccessMessage] = useState("");
  const [alertSuccessPopup, setAlertSuccessPopup] = useState(false);
  const [countryList, setCountryList] = useState([]);
  // AUTH CHECK
  if (!sessionStorage.getItem("isLoggedIn")) window.location.href = "/";
  const authData = JSON.parse(sessionStorage.getItem("authData"));
  if (
    authData &&
    !authData.adminRole.permissions.includes("manage_foodservicepartners")
  ) {
    window.location.href = "/unauthorized";
  }
  // FETCH DATA ON MOUNT
  useEffect(() => {
    fetchCustomerLeadForms();
    fetchSectors(); 
  }, []);
  // FETCH CUSTOMER LEAD FORMS
  const fetchCustomerLeadForms = async () => {
    setIsLoading(true);
    try {
      const URL = BaseUrl + `admin/vendor-lead/list`;
      const response = await http.get(URL);

      if (response.data.success === true) {
        const leads = response.data.data.data.map((lead) => ({
          ...lead,
          sector: Number(lead.sector || lead.sectorId), // normalize
        }));
        // Sort by updatedAt (latest first)
        leads.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
        setCustomerLeadForms(leads);
        setTempList(leads);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };
  // FORMAT LEAD STATUS
  const formatLeadStatus = (status) => {
    if (!status) return "Incomplete";
    return status
      .toLowerCase()
      .replace(/_/g, " ")
      .replace(/\b\w/g, (c) => c.toUpperCase());
  };
  // GET SECTOR NAME
  const getSectorName = (sectorId) => {
    const sector = sectorOptions.find(
      (s) => String(s.value) === String(sectorId)
    );
    return sector ? sector.name : "-";
  };
  // EXPORT TO EXCEL
  const handleConfirmExport = () => {
    if (!customerLeadForms || customerLeadForms.length === 0) {
      setShowNoDataAlert(true);
      return;
    }
    setShowExportConfirm(true);
  };
  const getFilterLabelWithCount = (filter) => {
    const count = getFilterCount(filter);
    if (typeof filter === "object") {
      if (filter.type === "STEP") {
        return `Step ${filter.value} (${count})`;
      }
      if (filter.type === "COMPLETED") {
        return `Completed - ${
          filter.value === "AUTHORIZED" ? "Authorized" : "Unauthorized"
        } (${count})`;
      }
    }
    return `${filter.replace("_", " ")} (${count})`;
  };
  const getFilterLabel = (filter) => {
    if (typeof filter === "object") {
      if (filter.type === "STEP") {
        return `Step ${filter.value}`;
      }
      if (filter.type === "COMPLETED") {
        return `Completed - ${
          filter.value === "AUTHORIZED" ? "Authorized" : "Unauthorized"
        }`;
      }
    }
    return filter.replace("_", " ");
  };
  // EXPORT TO EXCEL FUNCTIONALITY
  const handleExportToExcel = () => {
    const leads = customerLeadForms;
    const headers = [
      t("name_txt"),
      t("email_address_txt"),
      t("phone_no_txt"),
      t("organization_name_txt"),
      t("addrees1_txt"),
      t("addrees2_txt"),
      t("addrees3_txt"),
      t("addrees4_txt"),
      t("addrees5_txt"),
      t("country_txt"),
      t("website_txt"),
      t("cus_sector_txt"),
      t("product_category_txt"),
      t("cus_product_description_txt"),
      t("monthly_capacity_txt"),
      t("lead_status_txt"),
      t("current_step_txt"),
      t("created_on_txt"),
      t("updated_on_txt"),
    ];
    const headerStyle = {
      font: { bold: true },
      alignment: { horizontal: "left" },
    };
    const styledHeaders = headers.map((header) => ({
      v: header,
      s: headerStyle,
    }));
    const rows = leads.map((lead) => [
      `${lead.firstName || ""} ${lead.lastName || ""}`.trim() || "-",
      lead.email || "-",
      lead.phone || "-",
      lead.companyName || "-",
      lead.apartment || "-",
      lead.street || "-", 
      lead.town || "-", 
      lead.county || "-", 
      lead.postcode || "-",
      lead.country || "-",
      lead.website || "-",
      getSectorName(lead.sector),
      lead.productCategories || "-",
      lead.productDescription || "-",
      lead.monthlyCapacity || "-",
      formatLeadStatus(lead.leadStatus),
      lead.stepCompleted === 3
        ? lead.emailVerified === true
          ? "Completed - Authorized"
          : "Completed - Unauthorized"
        : `Step ${lead.stepCompleted}`,
      moment(lead.createdAt).format("DD/MM/YYYY"),
      moment(lead.updatedAt).format("DD/MM/YYYY"),
    ]);
    // FIRST ROW TEXT
    const groupTexts = [];
    // SEARCH
    if (searchValue) {
      groupTexts.push(`Search: ${searchValue}`);
    }
    // STATUS FILTER WITH COUNT
    if (appliedFilterStatus.length > 0) {
      groupTexts.push(
        `Status: ${appliedFilterStatus
          .join(", ")}`
      );
    }
    // STEP / COMPLETED FILTER WITH COUNT
    if (appliedFilterSteps.length > 0) {
      groupTexts.push(
        `Onboarding: ${appliedFilterSteps
          .map(getFilterLabel)
          .join(", ")}`
      );
    }
    // TOTAL RECORDS
    groupTexts.push(`Total Records: ${leads.length}`);
    const firstRowText = groupTexts.join(" | ");
    const worksheetData = [
      [
        {
          v: firstRowText,
          s: { font: { bold: true }, alignment: { horizontal: "left" } },
        },
      ],
      styledHeaders,
      ...rows,
    ];
    const columnWidths = headers.map((h, i) => {
      let maxLength = h.length;
      rows.forEach((r) => {
        maxLength = Math.max(maxLength, String(r[i] || "").length);
      });
      return { wch: maxLength + 2 };
    });
    const ws = XLSX.utils.aoa_to_sheet(worksheetData);
    ws["!merges"] = [
      {
        s: { r: 0, c: 0 },
        e: { r: 0, c: headers.length - 1 },
      },
    ];
    ws["!cols"] = columnWidths;
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, t("cus_lead_txt"));
    const exportDateTime = moment().format("DD-MM-YYYY");
    const fileName = `${t("customer_lead_report_filename", { datetime: exportDateTime })}.xlsx`;
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, fileName);
    setShowExportConfirm(false);
  };
  // APPLY SEARCH FILTER
  const applySearch = (value = searchValue) => {
    const baseList = filteredList.length > 0 ? filteredList : tempList;
    if (!value) {
      setCustomerLeadForms(baseList); // restore filtered or all
      return;
    }
    const filtered = baseList.filter(
      (item) =>
        `${item.firstName || ""} ${item.lastName || ""}`.trim().toLowerCase().includes(value.toLowerCase()) ||
        item.email?.toLowerCase().includes(value.toLowerCase()),
    );
    setCustomerLeadForms(filtered);
  };
  // RESET SEARCH
  const resetSearch = () => {
    setSearchValue("");
    setCustomerLeadForms(filteredList.length > 0 ? filteredList : tempList);
  };
  // CONFIRM DELETE FORM
  const confirmDeleteForm = (row) => {
    setSelectedForm(row);
    setVisibleAlert(true);
  };
  // DELETE FORM
  const deleteForm = async () => {
    try {
      // close confirmation popup
      setVisibleAlert(false);
      // show loader
      setIsDeleting(true);
      const URL = BaseUrl + `admin/vendor-lead/delete/${selectedForm._id}`;
      const response = await http.delete(URL);
      if (response.data.success) {
        // remove from FULL list
        const updatedFullList = tempList.filter(
          (item) => item._id !== selectedForm._id,
        );
        setTempList(updatedFullList);
        // re-apply search if active
        if (searchValue) {
          applySearch(searchField, searchValue, updatedFullList);
        } else {
          setCustomerLeadForms(updatedFullList);
        }
        // hide loader
        setIsDeleting(false);
        setSelectedForm(null);
        // show success popup
        setAlertErrorMessage(t("lead_deleted_success_txt"));
        setAlertErrorPopup(true);
      }
    } catch (err) {
      console.error(err);
      // hide loader
      setIsDeleting(false);
      setAlertErrorMessage(t("failed_to_delete_lead_txt"));
      setAlertErrorPopup(true);
    }
  };
  const REQUIRED_FIELDS = [
    "firstName",
    "lastName",
    "email",
    "phone",
    "companyName",
    "apartment",
    "town",
    "county",
    "postcode",
    "sector",
    "productCategories",
  ];
  const hasAllMandatoryFields = (lead) => {
    return REQUIRED_FIELDS.every(
      (field) => lead[field] && lead[field].toString().trim() !== ""
    );
  };
  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  const handleCallConfirmYes = async () => {
    if (!selectedCallRow) return;
    setIsCallProcessing(true);
    setShowCallConfirm(false);
    await delay(400);
    const isValid = hasAllMandatoryFields(selectedCallRow);
      if (!isValid) {
        setIsCallProcessing(false); 
        setAlertErrorMessage(t("please_update_lead_before_call_completed_txt"));
        setAlertErrorPopup(true);
        return;
    }
    await markCallCompleted();
  };
  // MARK CALL AS COMPLETED
  const markCallCompleted = async () => {
    try {
      const URL = BaseUrl + `vendor-lead/updateCallStatus/${selectedCallRow._id}`;
      const response = await http.put(URL, {
        leadStatus: "CALL_COMPLETED",
      });
      if (response.data.success) {
        const updatedLead = response.data.data;
        const updatedList = customerLeadForms.map((item) =>
          item._id === updatedLead._id ? updatedLead : item,
        );
        setCustomerLeadForms(updatedList);
        setTempList(updatedList);
      } else {
        setAlertErrorMessage(t("faild_to_mark_complete_txt"));
        setAlertErrorPopup(true);
      }
    } catch (err) {
      console.error(err);
      setAlertErrorMessage(t("err_mark_complete_txt"));
      setAlertErrorPopup(true);
    } finally {
      setIsCallProcessing(false);
    }
  };
  // PUSH TO DATABASE
  const pushToDatabase = async () => {
    try {
      const URL = BaseUrl + `vendor-lead/update/${selectedPushRow._id}`;
      const response = await http.put(URL, {
        leadStatus: "CUSTOMER_PUSHED",
      });
      if (response.data.success) {
        const updatedList = customerLeadForms.map((item) =>
          item._id === selectedPushRow._id
            ? { ...item, leadStatus: "CUSTOMER_PUSHED" }
            : item,
        );
        setCustomerLeadForms(updatedList);
        setTempList(updatedList);
        closePushConfirm();
      } else {
        closePushConfirm();
        setAlertErrorMessage(t("faild_to_push_txt"));
        setAlertErrorPopup(true);
      }
    } catch (err) {
      console.error(err);
      closePushConfirm();
      setAlertErrorMessage(t("error_push_txt"));
      setAlertErrorPopup(true);
    }
  };
  const showAlertWithLoader = (message) => {
    setIsApproving(true); // show loader
    setShowApprovePopup(false); // close approve popup
    setTimeout(() => {
      setIsApproving(false); // hide loader
      setAlertErrorMessage(message);
      setAlertErrorPopup(true); // show alert on top
    }, 200); // small delay to ensure loader is visible
  };
  // APPROVE LEAD WITH TYPE(MANUAL OR AUTO)
  const submitApproveWithPush = async () => {
    setIsApproving(true);
    setShowApprovePopup(false);
    await new Promise((r) => setTimeout(r, 200));
    // AUTHORIZATION CHECK
    if (!selectedApproveRow?.emailVerified) {
      showAlertWithLoader(t("please_authorize_food_service_partner_before_approving_lead_txt"));
      return;
    }
    // validation
    let hasError = false;
    if (!pushType) {
      setPushTypeError(true);
      hasError = true;
    }
    if (!approveComment.trim()) {
      setCommentError(true);
      hasError = true;
    }
    if (hasError) {
      setIsApproving(false); // hide loader
      setShowApprovePopup(true); // reopen approve popup for correction
      return;
    }
    try {
      const URL = BaseUrl + `admin/vendor-lead/approve`;
      const response = await http.post(URL, {
        leadId: selectedApproveRow._id,
        pushType,
        comments: approveComment,
      });
      if (response.data.success) {
        const updatedLead = response.data.data;

        const updatedList = customerLeadForms.map((item) =>
          item._id === updatedLead._id ? updatedLead : item,
        );
        setCustomerLeadForms(updatedList);
        setTempList(updatedList);
        // reset popup state
        setSelectedApproveRow(null);
        setPushType("");
        setApproveComment("");
      } else {
        showAlertWithLoader(t("faild_to_approve_txt"));
      }
    } catch (err) {
      console.error(err);
      showAlertWithLoader(t("err_approve_txt"));
    } finally {
      setIsApproving(false);
    }
  };
  // FETCH APPROVAL LOGS
  const fetchApprovalLogs = async (lead) => {
    try {
      const URL = BaseUrl + `admin/vendor-lead/${lead._id}/approval-logs`;
      const response = await http.get(URL);
      if (response.data.success) {
        setApprovalLogs(response.data.data);
        setSelectedLogLead(lead);
        setShowLogPopup(true);
      }
    } catch (err) {
      console.error(err);
      setAlertErrorMessage("Failed to fetch approval logs");
      setAlertErrorPopup(true);
    }
  };
  // UPDATE LEAD AUTHORIZED
  const handleAuthorize = async () => {
    // CLOSE POPUP
    setShowAuthConfirm(false);
    // ALLOW REACT TO RENDER
    setTimeout(async () => {
      try {
        // SHOW LOADER
        setIsAuthorizing(true);
        const URL = `${BaseUrl}admin/vendor-lead/update/${selectedLead._id}`;
        const res = await http.put(URL, {
          emailVerified: true,
          emailVerifiedBy: authData.adminName,
        });
        if (res.data.success) {
          const updatedList = customerLeadForms.map((item) =>
            item._id === selectedLead._id
              ? { ...item, emailVerified: true, emailVerifiedBy: authData.adminName }
              : item,
          );
          setCustomerLeadForms(updatedList);
          setTempList(updatedList);
          setShowAuthSuccess(true);
        }
      } catch (err) {
        console.error(err);
        setAlertErrorMessage(t("failed_to_authorize_food_service_partner_lead_txt"));
        setAlertErrorPopup(true);
      } finally {
        // HIDE LOADER
        setIsAuthorizing(false);
        setSelectedLead(null);
      }
    }, 0);
  };
  // OPEN CLOSE ALERTS AND POPUPS
  const closeAlert = () => {
    setVisibleAlert(false);
    setSelectedForm(null);
  };
  const openCallConfirm = (row) => {
    setSelectedCallRow(row);
    setShowCallConfirm(true);
  };
  const closeCallConfirm = () => {
    setShowCallConfirm(false);
    setSelectedCallRow(null);
  };
  const openApproveConfirm = (row) => {
    setSelectedApproveRow(row);
    setPushType("");
    setApproveComment("");
    setPushTypeError(false);
    setCommentError(false);
    setShowApprovePopup(true);
  };
  const openPushConfirm = (row) => {
    setSelectedPushRow(row);
    setShowPushConfirm(true);
  };
  const closePushConfirm = () => {
    setShowPushConfirm(false);
    setSelectedPushRow(null);
  };
  const openViewPopup = (row) => {
    setSelectedViewLead({
      ...row,
      sector: Number(row.sector || row.sectorId),
    });
    setShowViewPopup(true);
  };
  const closeViewPopup = () => {
    setShowViewPopup(false);
    setSelectedViewLead(null);
  };
  const openAuthorizePopup = (row) => {
    setSelectedLead(row);
    setShowAuthConfirm(true);
  };
  const statusRank = {
    INCOMPLETE: 0,
    CALL_COMPLETED: 1,
    APPROVED: 2,
    CUSTOMER_PUSHED: 3,
  };
  // STATUS CHECKERS
  const isCallCompleted = (row) => {
    return statusRank[row.leadStatus] >= 1;
  };
  const isApproved = (row) => {
    return statusRank[row.leadStatus] >= 2;
  };
  const isPushed = (row) => {
    return statusRank[row.leadStatus] >= 3;
  };
  const toggleStatusFilter = (value) => {
    setDraftFilterStatus((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value],
    );
  };
  const toggleStepFilter = (filter) => {
    setDraftFilterSteps((prev) =>
      prev.some((f) => JSON.stringify(f) === JSON.stringify(filter))
        ? prev.filter((f) => JSON.stringify(f) !== JSON.stringify(filter))
        : [...prev, filter]
    );
  };
  const removeStatusFilter = (e, value) => {
    e.stopPropagation();
    setFilterStatus((prev) => prev.filter((v) => v !== value));
  };
  const removeStepFilter = (e, value) => {
    e.stopPropagation();
    setFilterSteps((prev) => prev.filter((v) => v !== value));
  };
  // APPLY MORE FILTERS
  const applyMoreFilters = () => {
    setAppliedFilterStatus(draftFilterStatus);
    setAppliedFilterSteps(draftFilterSteps);
    let filtered = [...tempList];
    if (draftFilterStatus.length > 0) {
      filtered = filtered.filter((item) =>
        draftFilterStatus.includes(item.leadStatus),
      );
    }
    if (draftFilterSteps.length > 0) {
      filtered = filtered.filter((item) =>
        draftFilterSteps.some((filter) => {
          if (filter.type === "STEP") {
            return item.stepCompleted === filter.value;
          }
          if (filter.type === "COMPLETED") {
            return (
              item.stepCompleted === 3 &&
              (filter.value === "AUTHORIZED"
                ? item.emailVerified === true
                : item.emailVerified !== true)
            );
          }
          return false;
        })
      );
    }
    setFilteredList(filtered);
    setCustomerLeadForms(filtered);
    setShowMoreFilter(false);
  };
  // CLEAR MORE FILTERS
  const clearMoreFilters = () => {
    // clear draft filters
    setDraftFilterStatus([]);
    setDraftFilterSteps([]);
    // clear applied filters
    setAppliedFilterStatus([]);
    setAppliedFilterSteps([]);
    // reset table
    setFilteredList([]);
    setCustomerLeadForms(tempList);
    // close popup
    setShowMoreFilter(false);
  };
  const selectedFilters = [...appliedFilterStatus, ...appliedFilterSteps];
  const clearAllFilters = () => {
    setAppliedFilterStatus([]);
    setAppliedFilterSteps([]);
    setDraftFilterStatus([]);
    setDraftFilterSteps([]);
    setSearchValue("");
    setFilteredList([]);
    setCustomerLeadForms(tempList);
  };
  const removeSelectedFilter = (value) => {
    let newStatus = [...appliedFilterStatus];
    let newSteps = [...appliedFilterSteps];
    if (typeof value === "object") {
      newSteps = newSteps.filter(
        (f) => JSON.stringify(f) !== JSON.stringify(value)
      );
    } else {
      newStatus = newStatus.filter((v) => v !== value);
    }
    setAppliedFilterStatus(newStatus);
    setAppliedFilterSteps(newSteps);
    setDraftFilterStatus(newStatus);
    setDraftFilterSteps(newSteps);
    let filtered = [...tempList];
    if (newStatus.length > 0) {
      filtered = filtered.filter((item) =>
        newStatus.includes(item.leadStatus)
      );
    }
    if (newSteps.length > 0) {
      filtered = filtered.filter((item) =>
        newSteps.some((filter) => {
          if (filter.type === "STEP") {
            return item.stepCompleted === filter.value;
          }
          if (filter.type === "COMPLETED") {
            return (
              item.stepCompleted === 3 &&
              (filter.value === "AUTHORIZED"
                ? item.emailVerified === true
                : item.emailVerified !== true)
            );
          }
          return false;
        })
      );
    }
    setFilteredList(filtered);
    setCustomerLeadForms(filtered);
  };
  const formatFilterLabel = (value) => {
    if (typeof value === "object") {
      if (value.type === "STEP") {
        return `Step ${value.value}`;
      }
      if (value.type === "COMPLETED") {
        return `Completed - ${
          value.value === "AUTHORIZED" ? "Authorized" : "Unauthorized"
        }`;
      }
    }
    return value.replace("_", " ");
  };
  const getFilterCount = (filter) => {
    const base = customerLeadForms;
    return base.filter((item) => {
      if (typeof filter === "object") {
        if (filter.type === "STEP") {
          return item.stepCompleted === filter.value;
        }
        if (filter.type === "COMPLETED") {
          return (
            item.stepCompleted === 3 &&
            (filter.value === "AUTHORIZED"
              ? item.emailVerified === true
              : item.emailVerified !== true)
          );
        }
      }
      return item.leadStatus === filter;
    }).length;
  };
  const renderStepStatus = (row) => {
    if (row.stepCompleted === 3) {
      return getCompletedLabel(row);
    }
    return `Step ${row.stepCompleted}`;
  };
  const getCompletedLabel = (row) => {
    if (row.stepCompleted !== 3) return null;
    return row.emailVerified === true
      ? "Completed - Authorized"
      : "Completed - Unauthorized";
  };
  const openEditPopup = (row) => {
    // open popup immediately
    setShowEditPopup(true);
    setIsEditLoading(true);  // show loader
    setEditFormData({}); // clear previous form
    setEditErrors({});
    setSelectedLead(null);
    // Call single lead API
    (async () => {
    try {
    const res = await http.get(
      `${BaseUrl}admin/vendor-lead/${row._id}`
    );
    if (res.data.success) {
      const lead = res.data.data; // latest data
    setSelectedLead(lead);
    setEditFormData({
      firstName: lead.firstName || "",
      lastName: lead.lastName || "",
      email: lead.email || "",
      phone: lead.phone || "",
      companyName: lead.companyName || "",
      apartment: lead.apartment || "",
      street: lead.street|| "",
      county: lead.county || "", 
      town: lead.town || "",
      postcode: lead.postcode || "",
      sector: Number(lead.sector || lead.sectorId) || "",
      country: lead.country || "United Kingdom",
      productCategories: lead.productCategories || "",
      productDescription: lead.productDescription || "",
      website: lead.website || "",
      monthlyCapacity: lead.monthlyCapacity || "",
      stepCompleted: 3,
    });
    }
  } catch (err) {
    console.error("Failed to load lead for edit", err);
  } finally {
    setIsEditLoading(false);
  }
})();
  };
  const submitEditLead = async () => {
    let errors = {};
    if (!editFormData.firstName) errors.firstName = t("field_require_txt");
    if (!editFormData.lastName) errors.lastName = t("field_require_txt");
    if (!editFormData.email) errors.email = t("field_require_txt");
    if (!editFormData.phone) errors.phone = t("field_require_txt");
    if (!editFormData.companyName) errors.companyName = t("field_require_txt");
    if (!editFormData.apartment) errors.apartment = t("field_require_txt");
    if (!editFormData.county) errors.county = t("field_require_txt");
    if( !editFormData.town) errors.town = t("field_require_txt");
    if (!editFormData.postcode) {
      errors.postcode = t("field_require_txt");
    } 
    if (!editFormData.sector) errors.sector = t("field_require_txt");
    if (!editFormData.productCategories) errors.productCategories = t("field_require_txt");
    if (Object.keys(errors).length > 0) {
      setEditErrors(errors);
      return;
    }
    // EMAIL DUPLICATE CHECK
    const emailDuplicate = customerLeadForms.some(
      (lead) =>
        lead.email?.toLowerCase() === editFormData.email.toLowerCase() && // same email
        lead._id !== selectedLead._id // not the current lead
    );
    if (emailDuplicate) {
      setEditErrors((prev) => ({
        ...prev,
        email: t("this_email_id_is_already_in_use_txt"),
      }));
      return;
    }
    setIsSubmitLoading(true);
    try {
      const URL = `${BaseUrl}vendor-lead/update/${selectedLead._id}`;
      const payload = {
        isCompleted: true,
        ...editFormData,
      };
      const res = await http.put(URL, payload);
      if (res.data.success) {
        fetchCustomerLeadForms();
        setShowEditPopup(false);
        // Show success popup
        setAlertSuccessMessage(t("lead_details_updated_success_txt"));
        setAlertSuccessPopup(true);
      } else {
        setAlertErrorMessage(t("failed_to_update_lead_txt"));
        setAlertErrorPopup(true);
      }
    } catch (err) {
      console.error(err);
      setAlertErrorMessage(t("failed_to_update_lead_txt"));
      setAlertErrorPopup(true);
    } finally {
      setIsSubmitLoading(false);
    }
  };
  const productCategoryOptions = [
    t("pizza_txt"),
    t("pasta_short_txt"),
    t("burrito_txt"),
    t("desserts_txt"),
    t("pizza_and_pasta_txt"),
    t("all_txt"),
  ];
  const fetchSectors = async () => {
    try {
      setIsSectorLoading(true);
      const URL = `${BaseUrl}admin/product/masterentries/sectors`;
      const response = await http.get(URL);
      if (response.data?.success) {
        const sectors = response.data.data;
        const formatted = sectors.map((item) => ({
          name: item.MasterValue,
          value: item.MasterId,
        }));
        setSectorOptions(formatted);
      }
    } catch (err) {
      console.error("Failed to fetch sectors", err);
    } finally {
      setIsSectorLoading(false);
    }
  };
  const handleEditChange = (field, value) => {
    setEditFormData(prev => ({
      ...prev,
      [field]: value
    }));
    setEditErrors(prev => ({
      ...prev,
      [field]: ""
    }));
  };
  const handlePhoneChange = (e) => {
    const value = e.target.value;
    // Allow digits, +, space, (), comma
    const allowedRegex = /^[0-9+(),\s]*$/;
    if (!allowedRegex.test(value)) {
      return; // silently block invalid characters
    }
    if (value.length > 25) {
      return; // block if exceeds max length
    }
    setEditFormData((prev) => ({
      ...prev,
      phone: value,
    }));
    // Clear error immediately
    setEditErrors((prev) => ({
      ...prev,
      phone: "",
    }));
  };
  const handlePostcodeChange = (e) => {
    const value = e.target.value.toUpperCase();
    setEditFormData((prev) => ({
      ...prev,
      postcode: value,
    }));
    // empty clear error
    if (!value.trim()) {
      setEditErrors((prev) => ({ ...prev, postcode: "" }));
      return;
    }
    // valid clear error
    setEditErrors((prev) => ({ ...prev, postcode: "" }));
  };
  // refresh single lead latest status
  const refreshSingleLead = async (id) => {
    try {
      setRefreshingId(id);
      const res = await http.get(`${BaseUrl}admin/vendor-lead/${id}`);
      if (res.data.success) {
        const updated = {
          ...res.data.data,
          sector: Number(res.data.data.sector || res.data.data.sectorId),
        };
        setCustomerLeadForms((prev) =>
          prev.map((item) =>
            item._id === id ? updated : item
          )
        );
      }
    } catch (err) {
      console.error("Refresh failed", err);
    } finally {
      setRefreshingId(null);
    }
  }
  // TABLE COLUMNS
  const columns = [
    {
      name: t("name_txt"),
      selector: (row) => `${row.firstName || ""} ${row.lastName || ""}`.trim() || "-",
      sortable: true,
    },
    {
      name: t("email_address_txt"),
      selector: (row) => row.email || "-",
      sortable: true,
    },
    {
      name: t("phone_no_txt"),
      selector: (row) => row.phone || "-",
    },
    {
      name: t("current_step_txt"),
      cell: (row) => renderStepStatus(row),
      sortable: true,
    },
    {
      name: t("created_on_txt"),
      selector: (row) => dateformatwithuktime(row.createdAt),
      sortable: true,
    },
    {
      name: t("updated_on_txt"),
      selector: (row) => dateformatwithuktime(row.updatedAt),
      sortable: true,
    },
    {
      name: t("call_status_txt"),
      cell: (row) =>
        isCallCompleted(row) ? (
          <span className="price-ord-yes">
            <i className="fa fa-check" />
          </span>
        ) : (
          <a
            className={`title-tooltip title-up button btn-yes ${
              !canAction('manage_foodservicepartners', 'edit') ? "disabled-btn" : ""
            }`}
            data-title={t("mark_call_done_txt")}
            onClick={() => canAction('manage_foodservicepartners', 'edit') && openCallConfirm(row)}
            style={{ color: "white" }}
          >
            <i className="fa fa-phone" aria-hidden="true"></i>
          </a>
        ),
      ignoreRowClick: true,
    },
    {
      name: t("approval_status_txt"),
      cell: (row) => {
        if (isApproved(row)) {
          return <span className="price-ord-yes">{t("approved_txt")}</span>;
        }
        const isEnabled = statusRank[row.leadStatus] === 1;
        return (
          <a
            className={`title-tooltip title-up button data-pop-btn ${
              !isEnabled || !canAction('manage_foodservicepartners', 'edit') ? "disabled-btn" : ""
            }`}
            data-title={t("approve_lead_txt")}
            onClick={() => {
              if (isEnabled && canAction('manage_foodservicepartners', 'edit')) {
                openApproveConfirm(row);
              }
            }}
          >
            {t("approve_txt")}
          </a>
        );
      },
      ignoreRowClick: true,
    },
    // {
    //   name: t("customer_account_status_txt"),
    //   cell: (row) => {
    //     if (isPushed(row)) {
    //       return <span className="price-ord-yes">{t("account_created_txt")}</span>;
    //     }
    //      const isPushEnabled = statusRank[row.leadStatus] === 2;
    //     return (
    //       <a
    //         className={`title-tooltip title-up button data-pop-btn ${
    //       !isPushEnabled ? "disabled-btn" : ""
    //     }`}
    //     data-title={t("add_to_customer_database_txt")}
    //         onClick={() => {
    //           if (isPushEnabled) {
    //             openPushConfirm(row)}
    //           }
    //         }
    //       >
    //         {t("create_customer_account_txt")}
    //       </a>
    //     );
    //   },
    //   ignoreRowClick: true,
    // },
    {
      name: t("action_txt"),
      cell: (row) => (
        <div>
          {canAction('manage_foodservicepartners', 'view') && (
          <a
            className="button title-tooltip title-up"
            data-title={t("view_txt")}
            style={{ color: "white" }}
            onClick={() => openViewPopup(row)}
          >
            <i className="fa fa-eye" aria-hidden="true"></i>
          </a>
          )}
          {canAction('manage_foodservicepartners', 'edit') && !(row.stepCompleted === 3) && row.emailVerified === false && (
            <a
              className="button title-tooltip title-up"
              data-title={t("edit_txt")}
              style={{ color: "white" }}
              onClick={() => openEditPopup(row)}
            >
              <i className="fa fa-edit" aria-hidden="true"></i>
            </a>
          )}
          {canAction('manage_foodservicepartners', 'edit') && row.leadStatus === "CALL_COMPLETED" && row.stepCompleted === 3 && row.emailVerified === false && (
          <a
            className="button title-tooltip title-up"
            data-title={t("authorize_food_service_partner_txt")}
            style={{ color: "white" }}
            onClick={() => openAuthorizePopup(row)}
          >
            <i className="fa fa-shield" aria-hidden="true"></i>
          </a>
          )}
          <a
            className="button title-tooltip title-up"
            data-title={t("approval_log_note_txt")}
            style={{ color: "white" }}
            onClick={() => fetchApprovalLogs(row)}
          >
            <i className="fa fa-file-text-o"></i>
          </a>
          {/* DELETE – show only if NOT approved */}
          {row.leadStatus !== "APPROVED" &&
            row.leadStatus !== "CUSTOMER_PUSHED" && canAction('manage_foodservicepartners', 'delete') && (
              <a
                className="button title-tooltip title-up"
                data-title={t("delete_txt")}
                style={{ color: "white" }}
                onClick={() => confirmDeleteForm(row)}
              >
                <i className="fa fa-trash" aria-hidden="true"></i>
              </a>
          )}
          {canAction('manage_foodservicepartners', 'refresh') && (
          <a
            className="refresh-btn title-tooltip title-up"
            data-title={t("click_to_view_updated_status_and_details_of_this_lead_txt")}
            onClick={() => refreshSingleLead(row._id)}
          >
            <i
              className={`fa fa-refresh ${
                refreshingId === row._id ? "fa-spin" : ""
              }`}
              aria-hidden="true"
            ></i>

          </a>
          )}
        </div>
      ),
      ignoreRowClick: true,
    },
  ];
  // CUSTOM STYLES FOR DATATABLE
  const customStyles = {
    rows: { style: { minHeight: "40px" } },
    headCells: { style: { fontWeight: "600", padding: "10px" } },
    cells: { style: { padding: "10px" } },
  };
  // PAGINATION OPTIONS
  const paginationComponentOptions = {
    rowsPerPageText: "",
    rangeSeparatorText: "",
    selectAllRowsItem: true,
    selectAllRowsItemText: "",
    noRowsPerPage: "",
  };
  //fetch countries
  useEffect(() => {
    fetch("https://restcountries.com/v3.1/all?fields=name")
      .then((res) => {
        if (!res.ok) {
          throw new Error("Failed to load countries");
        }
          return res.json();
        })
        .then((data) => {
          const countries = data
            .map((c) => c.name?.common)
            .filter(Boolean)
            .sort();
          setCountryList(countries);
        })
        .catch((err) => {
          console.error("Country API error:", err);
      });
  }, []);
  // RENDER COMPONENT
  return (
    <section className="dashboard-block">
      <Sidebar />
      <div className="dash-left">
        <Header />
        <section className="cart-block">
          {alertErrorPopup && (
            <AlertPopup
              title={t("alert_txt")}
              message={alertErrorMessage}
              handleOk={() => setAlertErrorPopup(false)}
            />
          )}
          <div className="container">
            <div className="flex-title">
              <h1 className="checkout-title">{t("customer_lead_forms_txt")}</h1>
              <div className="prod-import-btn odr-expo-btn">
                {canAction('manage_foodservicepartners', 'export') && (
                  <a
                    data-title="Export Filtered Records"
                    className="export-btn button title-tooltip title-left"
                    onClick={handleConfirmExport}
                  >
                    {t("export_btn_txt")}
                  </a>
                )}
              </div>
            </div>
            <div className="checkout-table">
              {/* SEARCH */}
              <div className="table-filter search-orders">
                {/* SEARCH INPUT / DROPDOWN */}
                <div className="table-search-reset">
                  <div className="table-search">
                    <input
                      type="text"
                      className="form-control"
                      placeholder={t("search_by_name_email_txt")}
                      value={searchValue}
                      onChange={(e) => {
                        const value = e.target.value;
                        setSearchValue(value);
                        applySearch(value);
                      }}
                    />
                  </div>
                  <button
                    className="submitbtn button search-ord-btn"
                    onClick={() => applySearch(searchValue)}
                  >
                    <i className="fa fa-search"></i>
                  </button>
                  <button className="resetbtn" onClick={resetSearch}>
                    {t("reset_txt")}
                  </button>
                </div>
                {/* MORE FILTER SECTION */}
                {tempList?.length > 0 && (
                  <div
                    className={
                      selectedStatus
                        ? "select-drop"
                        : "select-drop no-filter-list"
                    }
                    ref={filterRef}
                  >
                    <a
                      className={
                        showMoreFilter
                          ? "filter-btn button active"
                          : "filter-btn button"
                      }
                      onClick={() => setShowMoreFilter(true)}
                    >
                      {t("more_filter_txt")}{" "}
                      <span className="filter-icon">
                        <i className="fa fa-sliders" aria-hidden="true"></i>
                      </span>
                    </a>
                  </div>
                )}
              </div>
              {selectedFilters.length > 0 && (
                <div className="filter-field-wrap">
                  <h3>{t("filteredby_txt")}</h3>
                  <div className="filter-show-bx">
                    {selectedFilters.map((item) => (
                      <span
                        className="filters"
                        key={JSON.stringify(item)}
                        onClick={() => removeSelectedFilter(item)}
                      >
                        <a className="filter-x"></a>
                        {formatFilterLabel(item)}:<span className="filter-count">{getFilterCount(item)}</span>
                      </span>
                    ))}
                    <span className="filters clr-all" onClick={clearAllFilters}>
                      {t("clearall_txt")}
                    </span>
                  </div>
                </div>
              )}
              {customerLeadForms.length > 0 && (
                <p className="note-text">{t("note_text_for_lead")}</p>
              )}
              <br />
              <div className="table_overflow customer_leadform_table">
                <DataTable
                  columns={columns}
                  data={customerLeadForms}
                  customStyles={customStyles}
                  pagination
                  paginationPerPage={25}
                  progressPending={isLoading}
                  paginationRowsPerPageOptions={[25, 50, 75, 100]}
                  paginationComponentOptions={paginationComponentOptions}
                  noDataComponent={
                    <div className="no-records-found">
                      {t("no_records_found_txt", {
                        recordType: t("customer_lead_forms_txt"),
                      })}
                    </div>
                  }
                />
              </div>
            </div>
            {/* DELETE POPUP */}
            {visibleAlert && (
              <ConfirmationPopup
                title={t("confirm_txt")}
                confirmationMessage={t("confirm_delete_lead_txt")}
                handleYes={() => deleteForm()}
                handleNo={() => closeAlert()}
              />
            )}
            {/* CALL CONFIRM POPUP */}
            {showCallConfirm && (
              <ConfirmationPopup
                title={t("confirm_txt")}
                confirmationMessage={t("call_completed_confirm_txt")}
                handleYes={handleCallConfirmYes}
                handleNo={() => closeCallConfirm()}
              />
            )}
            {/* PUSH CONFIRM POPUP */}
            {showPushConfirm && (
              <ConfirmationPopup
                title={t("confirm_txt")}
                confirmationMessage={t("pushtodb_confirm_txt")}
                handleYes={() => pushToDatabase()}
                handleNo={() => closePushConfirm()}
              />
            )}
            {/* EXPORT CONFIRM POPUP */}
            {showExportConfirm && (
              <ConfirmationPopup
                title={t("confirm_txt")}
                confirmationMessage={t("export_confirm_txt")}
                handleYes={() => handleExportToExcel()}
                handleNo={() => setShowExportConfirm(false)}
                yesButtonText={t("ok_txt")}
                noButtonText={t("cancel_txt")}
              />
            )}
            {/* NO DATA FOUND TO EXPORT POPUP */}
            {showNoDataAlert && (
              <AlertPopup
                title={t("alert_txt")}
                message={t("no_records_for_export_txt")}
                handleOk={() => setShowNoDataAlert(false)}
              />
            )}
            {showAuthConfirm && (
              <ConfirmationPopup
                title={t("confirm_txt")}
                confirmationMessage={t("confirm_authorize_food_service_partner_txt")}
                handleYes={handleAuthorize}
                handleNo={() => {
                  setShowAuthConfirm(false);
                  setSelectedLead(null);
                }}
              />
            )}
            {showAuthSuccess && (
              <AlertPopup
                title={t("alert_txt")}
                message={t("lead_authorized_success_txt")}
                handleOk={() => setShowAuthSuccess(false)}
              />
            )}
            {alertSuccessPopup && (
              <AlertPopup
                title={t("alert_txt")}
                message={alertSuccessMessage}
                handleOk={() => setAlertSuccessPopup(false)}
              />
            )}
            {/* VIEW LEAD POPUP */}
            {showViewPopup && selectedViewLead && (
              <Popup
                extClass="order-pop info-poup"
                headMoreTxt={
                  <div className="order-top">
                    <div className="head">
                      <h4>
                        {t("customer_lead_details_txt")} -{" "}
                        {selectedViewLead.email}{" "}
                      </h4>
                    </div>
                  </div>
                }
                bodyMoreTxt={
                  <div className="order-top">
                    <div className="bottom vendor-details vendor-table-view">
                      <table className="vendor-table">
                        <tr>
                          <td>{t("name_txt")}</td>
                          <td>{`${selectedViewLead.firstName || ""} ${selectedViewLead.lastName || ""}`.trim() || "-"}</td>
                        </tr>
                        <tr>
                          <td>{t("email_address_txt")}</td>
                          <td>{selectedViewLead.email || "-"}</td>
                        </tr>
                        <tr>
                          <td>{t("phone_no_txt")}</td>
                          <td>{selectedViewLead.phone || "-"}</td>
                        </tr>
                        <tr>
                          <td>{t("organization_name_txt")}</td>
                          <td>{selectedViewLead.companyName || "-"}</td>
                        </tr>
                        <tr>
                          <td>{t("address_txt")}</td>
                          <td>
                            {[
                              selectedViewLead.apartment,
                              selectedViewLead.street,
                              selectedViewLead.town,
                              selectedViewLead.county,
                              selectedViewLead.postcode,
                            ]
                              .filter(Boolean)
                              .join(", ") || "-"}
                          </td>
                        </tr>
                        <tr>
                          <td>{t("country_txt")}</td>
                          <td>{selectedViewLead.country || "-"}</td>
                        </tr>
                        <tr>
                          <td>{t("website_txt")}</td>
                          <td>{selectedViewLead.website || "-"}</td>
                        </tr>
                        <tr>
                          <td>{t("cus_sector_txt")}</td>
                          <td>
                            {getSectorName(selectedViewLead.sector) || "-"}
                          </td>
                        </tr>
                        <tr>
                          <td>{t("product_category_txt")}</td>
                          <td>{selectedViewLead.productCategories || "-"}</td>
                        </tr>
                        <tr>
                          <td>{t("cus_product_description_txt")}</td>
                          <td>{(selectedViewLead.productDescription === 'All')? `All (Pizza, Pasta, Burrito, Desserts, Pizza and Pasta)` : selectedViewLead.productDescription || "-"}</td>
                        </tr>
                        <tr>
                          <td>{t("monthly_capacity_txt")}</td>
                          <td>{selectedViewLead.monthlyCapacity || "-"}</td>
                        </tr>
                        <tr>
                          <td>{t("email_verified_by_txt")}</td>
                          <td>
                            {selectedViewLead.emailVerifiedBy === "Vendor"
                              ? t("food_service_partner_txt")
                              : selectedViewLead.emailVerifiedBy || "-"}
                          </td>
                        </tr>
                        <tr>
                          <td>{t("lead_status_txt")}</td>
                          <td>
                            {formatLeadStatus(selectedViewLead.leadStatus)}
                          </td>
                        </tr>
                        <tr>
                          <td>{t("current_step_txt")}</td>
                          <td>
                            {selectedViewLead.stepCompleted === 3
                              ? getCompletedLabel(selectedViewLead)
                              : `Step ${selectedViewLead.stepCompleted}`}
                          </td>
                        </tr>
                        <tr>
                          <td>{t("created_on_txt")}</td>
                          <td>
                            {dateformatwithuktime(selectedViewLead.createdAt)}
                          </td>
                        </tr>
                        <tr>
                          <td>{t("updated_on_txt")}</td>
                          <td>
                            {dateformatwithuktime(selectedViewLead.updatedAt)}
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                }
                closebtn={
                  <span onClick={closeViewPopup} className="close"></span>
                }
              />
            )}
            {showApprovePopup && (
              <div className="custom-alert-pop lead-approve-popup">
                <div className="custom-alert-container">
                  <div className="custom-alert-wrap">
                    <div className="custom-alert-header">
                      <h4>
                        {t("approve_lead_txt")} -{" "}
                        <span style={{ textTransform: "initial" }}>
                          {selectedApproveRow?.email || ""}
                        </span>
                      </h4>
                    </div>
                    <div className="custom-alert-body text-left">
                      {/* PUSH TYPE */}
                      <div className="input-field">
                        <label>{t("approval_type_txt")}</label>
                        <select
                          value={pushType}
                          onChange={(e) => {
                            setPushType(e.target.value);
                            setPushTypeError(false);
                          }}
                        >
                          <option value="">{t("select_type_txt")}</option>
                          <option value="MANUAL">{t("manual_push_txt")}</option>
                          <option value="AUTO">{t("auto_push_txt")}</option>
                        </select>
                        {pushTypeError && (
                          <div className="error-msg">
                            {t("field_require_txt")}
                          </div>
                        )}
                      </div>
                      {/* COMMENTS */}
                      <div className="input-field">
                        <span className="labeltxt">{t("post_comment_label_txt")}</span>
                        <textarea
                          value={approveComment}
                          onChange={(e) => {
                            setApproveComment(e.target.value);
                            setCommentError(false);
                          }}
                        />
                        {commentError && (
                          <div className="error-msg">
                            {t("field_require_txt")}
                          </div>
                        )}
                      </div>
                      {/* ACTION BUTTONS */}
                      <div className="alert-buttons">
                        <button
                          onClick={submitApproveWithPush}
                          className="popup-alert-btn button"
                        >
                          {t("submit_txt")}
                        </button>
                        <button
                          onClick={() => setShowApprovePopup(false)}
                          className="popup-alert-btn button"
                        >
                          {t("cancel_txt")}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {isDeleting && (
              <div className="loading-full-bg">
                <div className="loading-buffer"></div>
              </div>
            )}
            {isCallProcessing && (
              <div className="loading-full-bg">
                <div className="loading-buffer"></div>
              </div>
            )}
            {isApproving && (
              <div className="loading-full-bg">
                <div className="loading-buffer"></div>
              </div>
            )}
            {isAuthorizing && (
              <div className="loading-full-bg">
                <div className="loading-buffer"></div>
              </div>
            )}
            {showLogPopup && (
              <Popup
                extClass="info-poup show"
                closebtn={
                  <span
                    onClick={() => {
                      setShowLogPopup(false);
                      setApprovalLogs([]);
                      setSelectedLogLead(null);
                    }}
                    className="close"
                  />
                }
                headMoreTxt={
                  <div className="order-top">
                    <h4>
                      <span>
                        {selectedLogLead?.email || ""}
                      </span>
                    </h4>
                  </div>
                }
                bodyMoreTxt={
                  <div className="bottom vendor-details acc-log">
                    {approvalLogs.length > 0 ? (
                      approvalLogs.map((log) => {
                        const actionLabel =
                          log.pushType === "MANUAL"
                            ? "Approved (Manual Push)"
                            : "Approved (Auto Push)";
                        return (
                          <div className="info-item" key={log._id}>
                            <div className="info-innr">
                              <div className="flex-log-hdr">
                                <p>
                                  <span className="labeltxt acn-by">
                                    {actionLabel}
                                  </span>
                                </p>
                                <div className="hdrlog-rit">
                                  <span className="log-user">
                                    {log.performedByType}
                                  </span>
                                  <span className="log-line">|</span>
                                  <span className="log-date">
                                    {dateformatwithuktime(log.createdAt)}
                                  </span>
                                </div>
                              </div>
                              <p>
                                <span className="labeltxt log-reason">
                                  {t("comments_txt")}
                                </span>{" "}
                                {log.comments}
                              </p>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div className="no-logs">{t("no_logs_txt")}</div>
                    )}
                  </div>
                }
              />
            )}
            {showMoreFilter && (
              <div className="product-import-pop more-filter-pop">
                <div className="product-import-pop-overlay"></div>
                <div className="product-import-wrap">
                  <span
                    className="close-import-pop"
                    onClick={() => setShowMoreFilter(false)}
                  ></span>
                  <div className="product-import-body">
                    <div className="product-import-header">
                      <h3>{t("more_filters_txt")}</h3>
                    </div>
                    <div className="product-import-content">
                      {/* STATUS FILTER */}
                      <div className="filter-accordion-grp">
                        <h5>{t("status_txt")}</h5>
                        <div className="filter-options">
                          {["INCOMPLETE", "CALL_COMPLETED", "APPROVED"].map(
                            (status) => (
                              <a
                                key={status}
                                className={
                                  draftFilterStatus.includes(status)
                                    ? "filter-val active"
                                    : "filter-val"
                                }
                                onClick={() => toggleStatusFilter(status)}
                              >
                                {status.replace("_", " ")}
                                <span
                                  className="remove-filter"
                                  onClick={(e) => removeStatusFilter(e, status)}
                                ></span>
                              </a>
                            ),
                          )}
                        </div>
                      </div>
                      {/* ONBOARDING STEP FILTER */}
                      <div className="filter-accordion-grp">
                        <h5>{t("onboarding_status_txt")}</h5>
                        <div className="filter-options">
                          {/* STEP 1 */}
                          <a
                            className={
                              draftFilterSteps.some(f => f.type === "STEP" && f.value === 1)
                                ? "filter-val active"
                                : "filter-val"
                            }
                            onClick={() => toggleStepFilter({ type: "STEP", value: 1 })}
                          >
                            {t("step1_txt")}
                          </a>
                          {/* STEP 2 */}
                          <a
                            className={
                              draftFilterSteps.some(f => f.type === "STEP" && f.value === 2)
                                ? "filter-val active"
                                : "filter-val"
                            }
                            onClick={() => toggleStepFilter({ type: "STEP", value: 2 })}
                          >
                            {t("step2_txt")}
                          </a>
                          {/* COMPLETED - AUTH */}
                          <a
                            className={
                              draftFilterSteps.some(
                                f => f.type === "COMPLETED" && f.value === "AUTHORIZED"
                              )
                                ? "filter-val active"
                                : "filter-val"
                            }
                            onClick={() =>
                              toggleStepFilter({ type: "COMPLETED", value: "AUTHORIZED" })
                            }
                          >
                            {t("completed_auth_txt")}
                          </a>
                          {/* COMPLETED - UNAUTH */}
                          <a
                            className={
                              draftFilterSteps.some(
                                f => f.type === "COMPLETED" && f.value === "UNAUTHORIZED"
                              )
                                ? "filter-val active"
                                : "filter-val"
                            }
                            onClick={() =>
                              toggleStepFilter({ type: "COMPLETED", value: "UNAUTHORIZED" })
                            }
                          >
                            {t("completed_unauth_txt")}
                          </a>
                        </div>
                      </div>
                    </div>
                    {/* FOOTER */}
                    <div className="product-import-bottom">
                      <div className="filter-btns">
                        <button
                          type="button"
                          className="button clear-btn"
                          onClick={clearMoreFilters}
                        >
                          {t("clear_txt")}
                        </button>
                        <button
                          type="button"
                          className="button apply-btn"
                          onClick={applyMoreFilters}
                        >
                          {t("apply_txt")}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {showEditPopup && (
              <Popup
                extClass="order-pop info-poup"
                headMoreTxt={
                  <div className="order-top">
                    <div className="head">
                      {/* <h4>Edit Vendor Lead - {selectedLead?.email}</h4> */}
                      <h4>{t("edit_lead_txt")}</h4>
                    </div>
                  </div>
                }
                bodyMoreTxt={
                  isEditLoading || isSubmitLoading ? (
                    <div className="loading-buffer"></div>
                  ) : (
                  <div className="form-field bottom vendor-details">
                    <div className="input-field col-2">
                      <span className="labeltxt">{t("first_name_txt")}</span>
                      <span className="color-red">*</span>
                      <input
                        type="text"
                        value={editFormData.firstName}
                        onChange={(e) => handleEditChange("firstName", e.target.value)}
                      />
                      {editErrors.firstName && <div className="error-msg">{editErrors.firstName}</div>}
                    </div>
                    <div className="input-field col-2">
                      <span className="labeltxt">{t("last_name_txt")}</span>
                      <span className="color-red">*</span>
                      <input
                        type="text"
                        value={editFormData.lastName}
                        onChange={(e) => handleEditChange("lastName", e.target.value)}
                      />
                      {editErrors.lastName && <div className="error-msg">{editErrors.lastName}</div>}
                    </div>
                    <div className="input-field col-2">
                      <span className="labeltxt">{t("email_address_txt")}</span>
                      <span className="color-red">*</span>
                      <input 
                        type="text" 
                        value={editFormData.email} 
                        onChange={(e) => handleEditChange("email", e.target.value)}
                      />
                      {editErrors.email && <div className="error-msg">{editErrors.email}</div>}
                    </div>
                    <div className="input-field col-2">
                      <span className="labeltxt">{t("phone_no_txt")}</span>
                      <span className="color-red">*</span>
                      <input
                        type="text"
                        value={editFormData.phone}
                        onChange={handlePhoneChange}
                      />
                      {editErrors.phone && <div className="error-msg">{editErrors.phone}</div>}
                    </div>
                    <div className="input-field col-2">
                      <span className="labeltxt">{t("organization_name_txt")}</span>
                      <span className="color-red">*</span>
                      <input
                        type="text"
                        value={editFormData.companyName}
                        onChange={(e) => handleEditChange("companyName", e.target.value)}
                      />
                      {editErrors.companyName && <div className="error-msg">{editErrors.companyName}</div>}
                    </div>
                    <div className="input-field col-2">
                      <span className="labeltxt">{t("building_txt")}</span>
                      <span className="color-red">*</span>
                      <input
                        type="text"
                        value={editFormData.apartment}
                        onChange={(e) => handleEditChange("apartment", e.target.value)}
                      />
                      {editErrors.apartment && <div className="error-msg">{editErrors.apartment}</div>}
                    </div>
                    <div className="input-field col-2">
                      <span className="labeltxt">{t("street_txt")}</span>
                      <input
                        type="text"
                        value={editFormData.street}
                        onChange={(e)=> 
                          setEditFormData({ ...editFormData, street: e.target.value })
                        }
                      />
                    </div>
                    <div className="input-field col-2">
                      <span className="labeltxt">{t("town_txt")}</span>
                      <span className="color-red">*</span>
                      <input
                        type="text"
                        value={editFormData.town}
                        onChange={(e) => handleEditChange("town", e.target.value)}
                      />
                      {editErrors.town && <div className="error-msg">{editErrors.town}</div>}
                    </div>
                    <div className="input-field col-2">
                      <span className="labeltxt">{t("county_txt")}</span>
                      <span className="color-red">*</span>
                      <input
                        type="text"
                        value={editFormData.county}
                        onChange={(e) => handleEditChange("county", e.target.value)}
                      />
                      {editErrors.county && <div className="error-msg">{editErrors.county}</div>}
                    </div>
                    <div className="input-field col-2">
                      <span className="labeltxt">{t("postcode_txt")}</span>
                      <span className="color-red">*</span>
                      <input
                        type="text"
                        value={editFormData.postcode}
                        onChange={handlePostcodeChange}
                      />
                      {editErrors.postcode && <div className="error-msg">{editErrors.postcode}</div>}
                    </div>
                    <div className="input-field col-2">
                      <span className="labeltxt">{t("website_txt")}</span>
                      <input
                        type="text"
                        value={editFormData.website}
                        placeholder="www.example.com"
                        onChange={(e) => handleEditChange("website", e.target.value)}
                      />
                    </div>
                    <div className="input-field col-2">
                      <span className="labeltxt">{t("cus_sector_txt")}</span>
                      <span className="color-red">*</span>
                      <select
                        value={editFormData.sector}
                        onChange={(e) => handleEditChange("sector", e.target.value)}
                      >
                        <option value="">{t("select_sector_txt")}</option>
                        {sectorOptions.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.name}
                          </option>
                        ))}
                      </select>
                      {editErrors.sector && <div className="error-msg">{editErrors.sector}</div>}
                    </div>
                    <div className="input-field col-2">
                      <span className="labeltxt">{t("country_txt")}</span>
                      <span className="color-red">*</span>
                      <select
                        name="country"
                        value={editFormData.country || "United Kingdom"}
                        onChange={(e) =>
                          handleEditChange("country", e.target.value)
                        }
                      >
                        <option value="">{t("select_country_txt")}</option>
                        {countryList.map((country) => (
                          <option key={country} value={country}>
                            {country}
                          </option>
                        ))}
                      </select>
                      {editErrors.country && <div className="error-msg">{editErrors.country}</div>}
                    </div>
                    <div className="input-field col-2">
                      <span className="labeltxt">{t("product_category_txt")}</span>
                      <span className="color-red">*</span>
                      <select
                        value={editFormData.productCategories}
                        onChange={(e) => handleEditChange("productCategories", e.target.value)}
                      >
                        <option value="">{t("select_category_txt")}</option>
                        {productCategoryOptions.map(option => (
                          <option key={option} value={option}>
                            {option}
                          </option>
                        ))}
                      </select>
                      {editErrors.productCategories && <div className="error-msg">{editErrors.productCategories}</div>}
                    </div>
                    <div className="input-field col-2">
                      <span className="labeltxt">{t("cus_product_description_txt")}</span>
                      <select
                        value={editFormData.productDescription}
                        onChange={(e) => handleEditChange("productDescription", e.target.value)}
                      >
                        <option value="">{t("select_des_txt")}</option>
                        {productCategoryOptions.map(option => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                        ))}
                      </select>
                    </div>
                    <div className="input-field col-2">
                      <span className="labeltxt">{t("monthly_capacity_txt")}</span>
                      <input
                        type="text"
                        value={editFormData.monthlyCapacity}
                        onChange={(e) =>
                          setEditFormData({ ...editFormData, monthlyCapacity: e.target.value })
                        }
                      />
                    </div>
                    <div className="btn-field btn-center">
                      <button onClick={submitEditLead}>{t("submit_txt")}</button>
                      &nbsp;&nbsp;
                      <button onClick={() => setShowEditPopup(false)}>{t("cancel_txt")}</button>
                    </div>
                  </div>
                  )
                }
                closebtn={<span onClick={() => setShowEditPopup(false)} className="close"></span>}
              />
            )}
          </div>
        </section>
        <Footer />
      </div>
    </section>
  );
};

export default CustomerLeadForms;
